import { forwardRef, useEffect, useMemo, useRef } from "react";
import { Controller, useForm, useFormContext } from "react-hook-form";
import { useParams } from "react-router-dom";
import { MDBCol, MDBRow } from "mdbreact";

import "./C3ListOfVoyages.scss";

import { Button, Label, TextArea } from "abs-ui-components";

import { AUTOSAVE_SUCCESS_MESSAGE, c3Fields } from "../../Constants";
import { callApi } from "../../../../../services/MonitoringPlanService";
import { API_ROUTES } from "../../ApiRoutes/ApiRoutes";
import { emitToasterMsg } from "../../../../../services/toasterUtility";
import AutoSave from "../../../../../common/AutoSave/AutoSave";

const C3ListOfVoyages = forwardRef(({ c3VoyagesList, refetchMonitoringData,vesselMstId}, ref) => {
    const { control, getValues, reset, formState } = useFormContext();
    const lastManualSave = useRef(null);
    const manualSaveTriggered = useRef(false);

    useEffect(() => {
        if (c3VoyagesList) {
            reset(prev => ({ ...prev, c3: c3VoyagesList }));
        }
    }, [c3VoyagesList, reset]);

    const { dirtyFields } = formState;
    const isC3Dirty = !!(dirtyFields?.c3 && Object.keys(dirtyFields.c3).length > 0);

    AutoSave(ref, [], async () => {
        if (!isC3Dirty) return;
        await handleSave(true);
    });

    const handleSave = async (isAuto = false) => {
        const formValues = getValues("c3");
        const payload = {
            ...c3FieldsColumns.reduce((acc, { name }) => {
                acc[name] = formValues?.[name] || "";
                return acc;
            }, {}),
        };
        try {
            const C3ListOfVoyages = await callApi({
                method: "POST",
                url: API_ROUTES.C3(vesselMstId),
                data: payload,
            });
            if (C3ListOfVoyages?.isSuccess) {
                emitToasterMsg("success", "Table C.3", isAuto ? AUTOSAVE_SUCCESS_MESSAGE : "Created successfully");
                reset(prev => ({ ...prev, c3: formValues }));
                if (!isAuto) {
                    lastManualSave.current = Date.now();
                }
                if (typeof refetchMonitoringData === "function") {
                    await refetchMonitoringData();
                }
            }
            else {
                emitToasterMsg("error", "Table C.3", C3ListOfVoyages?.errorMessage);
            }
        } catch (error) {
            emitToasterMsg("error", "Table C.3", error?.errorMessage);
        }
    };

    const c3FieldsColumns = useMemo(() => {
        const base = c3Fields.filter(f => f.name !== "methodDescription");
        const responsibleField = {
            label: "Name of person or position responsible for this procedure",
            name: "responsiblePersonOrPosition",
            maxLength: 4000,
        };
        const i = base.findIndex(f => f.name === "descriptionOfProcedure");
        if (i !== -1) {
            base.splice(i + 1, 0, responsibleField);
        } else {
            base.push(responsibleField);
        }
        return base;
    }, []);

    return (
        <div className="form-section mt-5">
            <MDBRow className="mb-2">
                <MDBCol md="4">
                    <strong>Title of procedure</strong>
                </MDBCol>
                <MDBCol md="6">
                    <strong>Recording and safeguarding completeness of voyages</strong>
                </MDBCol>
            </MDBRow>

            {c3FieldsColumns.map(({ label, name, maxLength }) => (
                <MDBRow className="align-items-center mb-3" key={name}>
                    <MDBCol md="4">
                        <Label name={label} bold />
                    </MDBCol>
                    <MDBCol md="4">
                        <Controller
                            name={`c3.${name}`}
                            control={control}
                            render={({ field }) => (
                                <TextArea
                                    id={`c3_${name}`}
                                    className="textarea-resize"
                                    value={field.value || ""}
                                    onChange={field.onChange}
                                    placeholder=""
                                    maxLength={maxLength}
                                    row={1}
                                />
                            )}
                        />
                    </MDBCol>
                </MDBRow>
            ))}
            <div
                className="form-row"
                style={{ marginTop: "20px", display: "flex", justifyContent: "center" }}
            >
                <Button id="save_c3_btn"
                    disabled={!isC3Dirty}
                    onClick={async () => {
                        manualSaveTriggered.current = true;
                        await handleSave(false);
                    }}>
                    Save
                </Button>
            </div>
        </div>
    );
});

export default C3ListOfVoyages;
